export default {
  "nav.home": "Home",
  "nav.spreadsheet": "Spreadsheet",
  "nav.articles": "Guides",
  "nav.categories": "Categories",
  "nav.shoppingGuide": "Shopping Guide",

  "hero.seoTitle": "usfans Spreadsheet — Find Products & Save Money | usfanssheet.today",
  "hero.eyebrow": "THE USFANS SPREADSHEET RESOURCE",
  "hero.title": "usfans Spreadsheet — Find Products, Compare Options & Shop Smarter",
  "hero.subtitle": "Explore organized usfans spreadsheet finds, shopping guides and practical money-saving tips in one place.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Product Finds • Money-Saving Tips • Category Guides • Shopping Advice",

  "value.title": "Everything You Need to Shop Smarter in One Place",
  "value.subtitle": "Our usfans spreadsheet resource helps you browse products faster, understand categories and make better buying decisions.",
  "value.card1.title": "usfans Spreadsheet",
  "value.card1.desc": "Find organized product discoveries and useful product information across categories.",
  "value.card2.title": "Money-Saving Tips",
  "value.card2.desc": "Learn practical ways to compare options and stretch your shopping budget.",
  "value.card3.title": "Category Guides",
  "value.card3.desc": "Understand shoes, hoodies, t-shirts, jackets, bags and more before you buy.",
  "value.card4.title": "Shopping Advice",
  "value.card4.desc": "Follow simple step-by-step guidance to research and choose products with confidence.",
  "value.card5.title": "New Finds",
  "value.card5.desc": "Stay updated with fresh product ideas and trending picks across popular categories.",
  "value.card6.title": "Beginner Friendly",
  "value.card6.desc": "Easy-to-follow explanations designed for first-time spreadsheet shoppers.",

  "spreadsheet.title": "Browse Better Products With the usfans Spreadsheet",
  "spreadsheet.copy": "Searching through thousands of products can be time-consuming. Our usfans spreadsheet resource organizes useful product finds into easy-to-browse categories, so you can research faster and make more informed decisions before you buy.",
  "spreadsheet.cta": "Browse usfans Spreadsheet",

  "how.title": "How It Works",
  "how.subtitle": "A simple path from browsing to a confident purchase.",
  "how.step1": "Pick a category",
  "how.step2": "Explore product finds",
  "how.step3": "Review product details",
  "how.step4": "Compare your options",
  "how.step5": "Apply money-saving tips",
  "how.step6": "Continue to the main website",

  "popular.title": "Popular Searches",
  "popular.subtitle": "Topics people explore most when researching the usfans spreadsheet.",
  "popular.1": "usfans spreadsheet",
  "popular.2": "usfans spreadsheet finds",
  "popular.3": "usfans shopping tips",
  "popular.4": "usfans money saving",
  "popular.5": "usfans categories",
  "popular.6": "usfans guide",
  "popular.7": "usfans best finds",
  "popular.8": "usfans coupon",
  "popular.9": "usfans discount code",

  "categories.title": "Browse Categories",
  "categories.subtitle": "Jump straight to the products you care about on the main website.",
  "categories.dropdownLabel": "Choose a category",

  "safety.title": "Research Before You Buy",
  "safety.copy": "A good spreadsheet should help you research, not pressure you into a purchase. Compare products, review details and understand your options before making a decision.",
  "safety.cta": "Browse Categories",

  "articles.title": "usfans Spreadsheet Guides",
  "articles.subtitle": "Original, in-depth articles to help you shop and save smarter.",

  "final.title": "Ready to Explore the usfans Spreadsheet?",
  "final.copy": "Start with our guides, compare your options, and continue to the main website when you are ready.",
  "final.cta": "Explore usfans Spreadsheet",

  "footer.tagline": "An independent resource for usfans spreadsheet finds, guides and shopping tips.",
  "footer.disclaimer": "usfanssheet.today is an independent informational resource. Always verify destination links and current offers on the main website before purchasing.",
  "footer.mainSite": "Main website",
  "footer.allRights": "All rights reserved.",

  "article.backHome": "Back to home",
  "article.related": "Related articles",
  "article.updated": "Updated",

  "notFound.title": "Page not found",
  "notFound.subtitle": "The page you are looking for does not exist or has been moved.",
  "notFound.backHome": "Back to home",

  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
};